import { api } from '../api'

const state = {
  // facilities used for map-markers
  mapFacilities: [],
  mapFacilitiesLoaded: false,
  // facilities the customer is able/allowed to broadcast ads
  assignedFacilities: [],
  assignedFacilitiesLoaded: false,
}

const mutations = {
  'INIT_MAPFACILITIES'(state, payload) {
    state.mapFacilities = payload
  },
  'TOGGLE_MAPFACILITY_STATUS'(state) {
    state.mapFacilitiesLoaded = !state.mapFacilitiesLoaded
  },
  'INIT_ASSIGNEDFACILITIES'(state, payload) {
    state.assignedFacilities = payload
  },
  'TOGGLE_ASSIGNEDFACILITY_STATUS'(state) {
    state.assignedFacilitiesLoaded = !state.assignedFacilitiesLoaded
  },
}

const getters = {
  getMapFacilities: state => {
    return state.mapFacilities
  },
  getAssignedFacilitiesOverview: state => {
    return state.assignedFacilities.map(facility => {
      return {
        location: facility.Postalcode + ' ' + facility.Location,
        address: facility.street + ' ' + facility.housenumber,
        country: facility.Country,
        facilitynumberofapartments: facility.numberofapartments,
        facilitynumberofmonitors: facility.numberofmonitors,
        facilitygroups: facility.Publicitygroups
      }
    })
  },
  getAssignedFacilities: state => {
    return state.assignedFacilities
  },
  getMapFacilityStatus: state => {
    return state.mapFacilitiesLoaded
  },
  getAssignedFacilityStatus: state => {
    return state.assignedFacilitiesLoaded
  },
  // getFacilityNames: state => {
  //   return Array.from(state.assignedFacilities, f => f.Name)
  // },
  getPublicitygroupFacilityObjects: state => payload => {
    return state.assignedFacilities
      .filter(facility => {
        return payload.filter(pl => {
          return pl.value.includes(`${facility.street} ${facility.housenumber}`)
        })
      }).map(facility => {
        return {
          facilityid: facility.idFacility,
          businessid: facility.Business_id
        }
      })
  },
  getMapAvailableFacilities: state => {
    return state.mapFacilities.filter(facility1 => {
      return !state.assignedFacilities.some(facility2 => {
        return facility1.idFacility === facility2.idFacility
      })
    }).filter(fac => fac.Latitude && fac.Longitude)
  },
  getMapAssignedFacilities: state => {
    return state.assignedFacilities.filter(facility => {
      return facility.Longitude && facility.Latitude
    })
  },
  getAssignedFacilitiyCoordinates: state => {
    return state.assignedFacilities.filter(fac => { return fac.Latitude && fac.Longitude }).map(facility => {
      return L.latLng(facility.Latitude, facility.Longitude)
    })
  },
  getMapAssignedFacilityPopupInfos: (state) => (payload) => {
    let facilities = state.assignedFacilities.filter(facility => facility.Longitude !== null && facility.Latitude !== null)
    return `${facilities[payload].street} ${facilities[payload].housenumber}, \n
              Wohnungen: ${facilities[payload].numberofapartments}, Monitore: ${facilities[payload].numberofmonitors}`
  },
  getMapAvailableFacilityPopupInfos: (state, getters) => (payload) => {
    let facilities = getters.getMapAvailableFacilities
    return `${facilities[payload].Street}: ${facilities[payload].Housenumber}, \n 
              Wohnungen: ${facilities[payload].numberofapartments}`
  },
  // getPublicitygroupFacilityNames: state => payload => {
  //   return state.assignedFacilities.filter(facility => facility.Publicitygroups.find(group => group.Groupname === payload)).map(fac => fac.Name)
  // },
  getPublicitygroupFacilities: state => payload => {
    return state.assignedFacilities.filter(facility => facility.Publicitygroups.find(group => group.Groupname === payload))
  },
  getPublicitygroupFacilityGroupIds: state => payload => {
    return state.assignedFacilities.filter(facility => facility.Publicitygroups.find(group => group.Groupname === payload)).map(fac => fac.Publicitygroups)
  },
  getPublicitygroupFacilityAssignmentObjectsByIds: state => payload => {
    return state.assignedFacilities.filter(facility => payload.includes(facility.idFacility)).map(fac => {
      return {
        facilityid: fac.idFacility,
        businessid: fac.Business_id
      }
    })
  }
}

const actions = {
  loadMapFacilities: ({ commit, state, rootState }) => {
    // return 0 on success, return 1 on error
    return new Promise(resolve => {
      api.queryAPIServerGet(process.env.VUE_APP_ROOT_API + "/publicitycustomer/facilities/all/get", { pid: rootState.auth.pid, username: rootState.auth.Username }, (response) => {
        let res = response.data

        if (res.error) {
          console.error('An error occured. Please try again later.');
          resolve(1)
          return;
        }

        commit("INIT_MAPFACILITIES", res.data)

        if (!state.mapFacilitiesLoaded) {
          commit('TOGGLE_MAPFACILITY_STATUS')
        }
      })
    })
  },
  loadAssignedFacilities: ({ commit, state, rootState }) => {
    // return 0 on success, return 1 on error
    return new Promise(resolve => {
      api.queryAPIServerGet(process.env.VUE_APP_ROOT_API + "/publicitycustomer/facilities/assigned/get", { pid: rootState.auth.pid, username: rootState.auth.Username }, (response) => {
        let res = response.data

        if (res.error) {
          console.error('An error occured. Please try again later.');
          resolve(1)
          return;
        }

        commit("INIT_ASSIGNEDFACILITIES", res.data)

        if (!state.assignedFacilitiesLoaded) {
          commit('TOGGLE_ASSIGNEDFACILITY_STATUS')
        }
      })
    })
  },
}

export default {
  state,
  mutations,
  getters,
  actions
}
